export const offerCodeEnum = Object.freeze({
  INDIVIDUAL_HEALTH: 'INDIVIDUAL_HEALTH',
  INDIVIDUAL_PROTECTION_DAILY_BENEFIT: 'INDIVIDUAL_PROTECTION_DAILY_BENEFIT',
  SELF_EMPLOYED_WORKER_PROTECTION: 'SELF_EMPLOYED_WORKER_PROTECTION',
  GROUP_HEALTH: 'GROUP_HEALTH'
});
